import { IContent } from '@_entities/content';

import {
	CheckIcon,
	DeleteRedIcon,
	FileEditIcon,
	FolderMoveBlackIcon,
	ShareIcon,
} from '@_shared/icons';
import { eventPush, toastGenerate } from '@_shared/libs';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import * as Modal from '@_shared/ui/Modal';
import { Typography } from '@_shared/ui/Typography';

import { useContentDeletePopup, useContentTitleEditPopup, useFolderUpdateModal } from '../../hooks';
import * as S from './ContentOptionsModal.style';

function ToastCheckIcon() {
	return (
		<S.ToastCheckIcon>
			<CheckIcon />
		</S.ToastCheckIcon>
	);
}

interface IProps {
	content: IContent;
	isContentListPage: boolean;
	contentTitle?: string;
	isFolderDetailPage: boolean;
}

export function ContentOptionsModal({
	content,
	isContentListPage,
	contentTitle,
	isFolderDetailPage,
}: IProps) {
	const { popLayer } = useUILayerStore();

	const { openFolderUpdateModal } = useFolderUpdateModal(
		content,
		content.folderId,
		isFolderDetailPage,
	);
	const { openContentTitleEditPopup } = useContentTitleEditPopup(content, contentTitle ?? '');
	const { openContentDeletePopup } = useContentDeletePopup(content, isContentListPage);

	return (
		<Modal.Container isButton={false} closeModal={popLayer}>
			<S.Container>
				{isContentListPage && (
					<S.Option
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							openContentTitleEditPopup();
						}}
					>
						<FileEditIcon />
						<Typography type="title-large" color="font-secondary">
							콘텐츠 제목 수정
						</Typography>
					</S.Option>
				)}
				<S.Option
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						openFolderUpdateModal();
					}}
				>
					<FolderMoveBlackIcon />
					<Typography type="title-large" color="font-secondary">
						폴더 이동
					</Typography>
				</S.Option>
				<S.Option
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						eventPush('공유하기.click');
						window.navigator.clipboard.writeText(content.URL);
						toastGenerate({
							LeftIcon: ToastCheckIcon,
							message: (
								<>
									링크가 복사되었어요!
									<br />
									원하는 곳에 붙여넣어 보세요 :)
								</>
							),
						});
						popLayer();
					}}
				>
					<ShareIcon />
					<Typography type="title-large" color="font-secondary">
						콘텐츠 공유
					</Typography>
				</S.Option>
				<S.Option
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						openContentDeletePopup();
					}}
				>
					<DeleteRedIcon />
					<Typography type="title-large" color="red-primary">
						콘텐츠 삭제
					</Typography>
				</S.Option>
			</S.Container>
		</Modal.Container>
	);
}
